import { Dialog, Tooltip } from '@mui/material'
import { useState } from 'react'
import Psychology from '@mui/icons-material/Psychology'
import { getBookedSlotStripColor } from 'src/clinic/components/ClinicManageBookingsPage/DayViewCalendarComponent'
import PastTherapyReportDialog from 'src/clinic/components/ClinicManageBookingsPage/pastTherapyReports/PastTherapyReportDialog'
import { PastTherapyReportDialogPaper } from 'src/clinic/components/ClinicManageBookingsPage/receiptPrinting/styledComponents'

export default function InTherapyButton({ bookedSlot, slotBlocked }) {
  const [pastTherapyReportsDialog, setPastTherapyReportsDialog] = useState({
    open: false,
    bookedEventData: null,
  })

  function closePastTherapyReportsDialog() {
    setPastTherapyReportsDialog((prev) => ({ ...prev, open: false }))
  }

  const colors = getBookedSlotStripColor(bookedSlot, slotBlocked)

  return (
    <>
      {' '}
      <Tooltip title="In therapy – view past reports" placement="top" arrow>
        <div
          id="in-therapy-strip"
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px 8px',
            marginRight: '8px',
            cursor: 'pointer',
            borderRight: `2px solid ${colors?.inTherapyBorderColor}`,
            background: colors?.inTherapyColor,
            color: colors?.inTherapyTextColor,
            borderRadius: '0 4px 4px 0',
            boxShadow: 'inset -2px 0 4px rgba(0, 0, 0, 0.05)',
            transition: 'all 0.2s ease',
            minWidth: '36px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = '0.9'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = '1'
          }}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setPastTherapyReportsDialog((prev) => ({
              ...prev,
              open: true,
              bookedEventData: bookedSlot,
            }))
          }}
        >
          <Psychology
            sx={{
              fontSize: '22px',
              color: 'inherit',
              filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2))',
            }}
          />
        </div>
      </Tooltip>{' '}
      <Dialog
        open={pastTherapyReportsDialog.open}
        PaperComponent={PastTherapyReportDialogPaper}
        onClose={closePastTherapyReportsDialog}
      >
        <PastTherapyReportDialog
          bookedEvent={pastTherapyReportsDialog.bookedEventData}
          closeDialog={closePastTherapyReportsDialog}
        />
      </Dialog>
    </>
  )
}
